import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {NegocioMetricasClass, NegocioViewModel} from '@utils/ViewModels';
import {PATH_NEGOCIO_DETAIL} from '../../../../navigation/navigation.module';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {
  CONFIRMACION_VALUES,
  getFuenteName,
  NEGOCIO_TYPE_DISPO,
  NEGOCIO_TYPE_FORWARD,
  NEGOCIO_TYPE_INTENCION, NEGOCIO_TYPE_INTENCION_ID,
  NEGOCIO_TYPE_ORDEN, NEGOCIO_TYPE_ORDEN_ID,
  NEGOCIO_TYPE_PAGO_DIFERIDO,
  NegociosService
} from '@services/negocios-service';
import {NEG_ACTIONS, PERM_ACCIONES_ID, PermisosService} from '@services/permisos-service';
import {DialogsService} from '@services/dialogs-service';
import {SpinnerService} from '@services/spinner-service';
import {MdMenuTrigger} from '@angular/material';
import {fromEvent} from 'rxjs/observable/fromEvent';
import {Subject} from 'rxjs/Subject';
import {ChipDisplay, FilterType, GenFilterFechaFromTo, IQuickFilters, NC, NegociosFilter} from '../negocio-filter';
import {Breakpoints, BreakpointsObserverService} from '@services/breakpoints-observer.service';
import {NegNewFiltersDialogData} from './neg-new-filters-dialog/neg-new-filters-dialog.component';
import {PreciosService} from '@services/precios-service';
import {SignalrService} from '../../../../signalr/signalR.service';

@Component({
  selector: 'app-negocio-list',
  templateUrl: './negocio-list.component.html',
  styleUrls: ['./negocio-list.component.scss']
})
export class NegocioListComponent implements OnInit, AfterViewInit, OnDestroy {

  readonly NEGOCIO_TYPE_FORWARD = NEGOCIO_TYPE_FORWARD;
  readonly NEGOCIO_TYPE_DISPO = NEGOCIO_TYPE_DISPO;
  readonly NEGOCIO_TYPE_PAGO_DIFERIDO = NEGOCIO_TYPE_PAGO_DIFERIDO;
  readonly getFuenteName = getFuenteName;
  readonly NCc = NC;
  readonly NEG_ACTIONS = NEG_ACTIONS;

  private precioEspecialArray = [CONFIRMACION_VALUES.ACTIVA, CONFIRMACION_VALUES.MATCHEADA,
    CONFIRMACION_VALUES.AUTORIZADA, CONFIRMACION_VALUES.CONFIRMADA];
  autorizanteArray = [CONFIRMACION_VALUES.CONFIRMADA, CONFIRMACION_VALUES.AUTORIZADA,
    CONFIRMACION_VALUES.NO_AUTORIZADA, CONFIRMACION_VALUES.MATCHEADA];

  columns: NegocioColumn[] = [NC.hora, NC.confirmacion, NC.fechaEstado, NC.tipo, NC.cliente, NC.producto, NC.tns, NC.negocio,
    NC.entrega, NC.cosecha, NC.moneda, NC.base, NC.precio, NC.precioEspecial, NC.match, NC.autorizante, NC.responsable,
    NC.acopio, NC.zona, NC.vencimiento, NC.creacion, NC.mercado, NC.fuente];

  filters = new NegociosFilter([
    {name: NC.hora.name, type: FilterType.FechaFromTo, data: {
      from: moment().subtract(15, 'day').startOf('day').toDate(),
      to: moment().endOf('day').toDate(),
    }},
    {name: NC.confirmacion.name, type: FilterType.Select, data:
      this.negociosService.getConfirmacionOptions().filter(o => [
        CONFIRMACION_VALUES.ACTIVA,
        CONFIRMACION_VALUES.MATCHEADA,
        CONFIRMACION_VALUES.EN_PROCESO,
        CONFIRMACION_VALUES.CONFIRMADA,
        CONFIRMACION_VALUES.GENERACION_AVISO,
        CONFIRMACION_VALUES.AVISO_GENERADO,
        CONFIRMACION_VALUES.FINALIZADO
      ].indexOf(o.Value) >= 0).map(conf => {
        return {
          displayValue: conf.Value,
          Id: conf.ID,
          rawValue: JSON.stringify(conf),
        };
      })
    },
    {name: NC.fechaEstado.name, type: FilterType.FechaFromTo, data: null},
    {name: NC.tipo.name, type: FilterType.Select, data: null},
    {name: NC.cliente.name, type: FilterType.Cliente, data: null},
    {name: NC.producto.name, type: FilterType.Select, data: null},
    {name: NC.tns.name, type: FilterType.NumberFromTo, data: null},
    {name: NC.negocio.name, type: FilterType.Select, data: null},
    {name: NC.entrega.name, type: FilterType.Select, data: null},
    {name: NC.cosecha.name, type: FilterType.Select, data: null},
    {name: NC.moneda.name, type: FilterType.Select, data: null},
    {name: NC.base.name, type: FilterType.NumberFromTo, data: null},
    {name: NC.precio.name, type: FilterType.NumberFromTo, data: null},
    {name: NC.precioEspecial.name, type: FilterType.NumberFromTo, data: null},
    {name: NC.match.name, type: FilterType.Select, data: null},
    {name: NC.autorizante.name, type: FilterType.Autorizante, data: null},
    {name: NC.responsable.name, type: FilterType.Colaborador, data: null},
    {name: NC.acopio.name, type: FilterType.Acopio, data: null},
    {name: NC.zona.name, type: FilterType.Select, data: null},
    {name: NC.vencimiento.name, type: FilterType.FechaFromTo, data: null},
    {name: NC.creacion.name, type: FilterType.FechaFromTo, data: null},
    {name: NC.mercado.name, type: FilterType.Select, data: null},
    {name: NC.fuente.name, type: FilterType.Select, data: null},
  ]);

  _simulator = false;
  tableWidth = 0;

  quickFilters = false;
  @Input() set simulator(value: boolean) {
    this._simulator = coerceBooleanProperty(value);
  }

  // Este es el payload request para el simulador
  @Input() payload: any = [];

  _cliente = false;
  @Input() set cliente(value: boolean) {
    this._simulator = coerceBooleanProperty(value);
  }

  @Input() loading = false;

  _rows: NegocioListItem[] = [];

  selectedIndex = -1;

  // SCROLLERS: verificar el funcionamiento en onHorizontalScroll();
  lastScrolled = '';
  canScroll = true;
  scrollTimer = 0;

  verticalScroll: HTMLDivElement;
  topScrollerSeparation = 0;
  @ViewChild('metricas') metricasDiv: ElementRef;
  @ViewChild('quickFiltersDiv') quickFiltersDiv: ElementRef;

  // paginador
  public pageSize = 25;
  public currentPage = 0;
  public resultsPageCount = 0;
  public resultsFullCount = 0;
  public marginLeft = '0px';

  sortColumn: NegocioColumn = NC.hora;
  sortOrder = false;

  @ViewChild(MdMenuTrigger) triggerMenu: MdMenuTrigger;

  isMobile = false;
  isTablet = false;
  destroySubject = new Subject<void>();

  metricasValues = new NegocioMetricasClass();
  chips: ChipDisplay[] = [];

  quickFiltersModels: IQuickFilters = {
    Hoy: false,
    Ordenes: false,
    Intenciones: false,
    Matches: false,
    Confirmadas: false,
    Vencidas: false,
  };
  constructor(
    private router: Router,
    private permisosService: PermisosService,
    private dialogsService: DialogsService,
    private spinnerService: SpinnerService,
    public negociosService: NegociosService,
    public breakpointsService: BreakpointsObserverService,
    private preciosService: PreciosService,
    private signalRService: SignalrService,
    private cd: ChangeDetectorRef
  ) {
    breakpointsService.observe([Breakpoints.XSmall])
      .map(x => x.matches)
      .takeUntil(this.destroySubject)
      .subscribe(x => {
        this.isMobile = x;
      });

    breakpointsService.observe([Breakpoints.Small])
      .map(x => x.matches)
      .takeUntil(this.destroySubject)
      .subscribe(x => {
        this.isTablet = x;
      });

      if(this.negociosService.negociosFiltersAndSort) {
        const { filters, sort, quickFilters, currentPage, pageSize } = this.negociosService.negociosFiltersAndSort;
        this.filters = filters;
        this.sortColumn = sort.column;
        this.sortOrder = sort.order;
        this.quickFiltersModels = quickFilters;
        this.currentPage = currentPage;
        this.pageSize = pageSize;
      } else {
        this.negociosService.negociosFiltersAndSort = {
          filters: this.filters,
          sort: {
            column: this.sortColumn,
            order: this.sortOrder,
          },
          quickFilters: this.quickFiltersModels,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        }
      }
  }

  normalizeFilters() {
    // por defecto si no hay filtro de fecha alguno, el filtro de fecha de creacion se debe setear de 15 dias atras a hoy
    const hasDateFilter = this.filters.filters.some(filter => {
      return [NC.creacion.name, NC.vencimiento.name, NC.hora.name, NC.fechaEstado.name].includes(filter.name) && filter.data !== null;
    });
    if (!hasDateFilter) {
      const filterData: GenFilterFechaFromTo = {
        from: moment().subtract(15, 'days').toDate(),
        to: moment().endOf('day').toDate()
      };
      this.filters.setSingleFilter(NC.creacion.name, filterData);
    }
  }

  ngOnInit() {
    if (this._simulator) {
      this.columns = this.columns.filter(x => {
        // eliminamos estas columnas
        return ![
          NC.creacion.name,
          NC.confirmacion.name,
          NC.hora.name,
          NC.precioEspecial.name,
          NC.match.name,
          NC.autorizante.name,
          NC.zona.name,
          NC.fuente.name].includes(x.name);
      });
      // la columna creacion se quito antes dado que va en una ubicacion distinta dependiendo si estamos en simulador o no
      this.columns.unshift(NC.actualizar, NC.creacion);

      this.spinnerService.setShowFlag(true);
      this.preciosService.simulatePrecios(this.payload).take(1).subscribe(response => {
          this._rows = this.updateNegociosResponse(response.Negocios || []);
          this.metricasValues.setValues(response.Metricas);
          if (this._rows.length) {
            this._rows.forEach(x => {
              x.needUpdate = x.Confirmacion.Estado === CONFIRMACION_VALUES.CONFIRMADA ||
                x.Confirmacion.Estado === CONFIRMACION_VALUES.MATCHEADA;
              x.updatePriceCheck = false;
            });
            // hacer un sort para tener las filas que necesitan actualizacion arriba
            this._rows.sort((a, b) => (a.needUpdate === b.needUpdate) ? 0 : a.needUpdate ? -1 : 1);
          }
          this.spinnerService.setShowFlag(false);
        },
        () => this.spinnerService.setShowFlag(false)
      );

    } else if (this._cliente) {
      this.columns = this.columns.filter(x => x.name !== NC.cliente.name);
    } else {
      this.columns = this.columns.filter(x => x.name !== NC.actualizar.name); // quitamos actualizar
      this.updateChips();
      this.getNegocios();

      // nos msuscribimos a SignalR
      this.signalRService.newNegocioMessage
        .takeUntil(this.destroySubject)
        .subscribe(x => this.onNewNegocioSignalR(x));

    }
    this.tableWidth = this.columns.reduce((acc, curr) => acc + curr.width, 0);
  }

  ngAfterViewInit() {
    // CUSTOM VERTICAL SCROLL CON STICKY HEADER
    this.verticalScroll = window.document.querySelector('.mat-drawer-content');
    if (this._simulator) { return; }

    // No podemos usar @HostListener('document:scroll'... porque el scroll vertical no está en el documento
    // sino en el div .mat-drawer-content
    fromEvent<UIEvent>(this.verticalScroll, 'scroll').takeUntil(this.destroySubject).subscribe(() => {
      // el offset inicial es 114 por el header
      let topOffset = 10 + 114 + this.metricasDiv.nativeElement.offsetHeight + this.quickFiltersDiv.nativeElement.offsetHeight;
      topOffset = this.isMobile ? topOffset - 9 : topOffset; // en mobile, el header pierde 9px
      if (this.verticalScroll.scrollTop > topOffset) {
        this.topScrollerSeparation = this.verticalScroll.scrollTop - topOffset;
      } else {
        this.topScrollerSeparation = 0;
      }
    });
  }

  ngOnDestroy() { this.destroySubject.next(); }

  onNewNegocioSignalR(negocio: NegocioViewModel) {
    if (negocio && !this._simulator) {
      // verificamos si el negocio ya se encuentra en la lista, si es así lo eliminamos dado que es una edición
      const index = this._rows.findIndex(val => val.Id === negocio.Id);
      if (index >= 0) {
        this._rows.splice(index, 1);
      } else {
        this.resultsFullCount++;
      }
      // finalmente colocamos el negocio en primer lugar de la lista, luego de pasarlo por la modificacion de datos
      this._rows.unshift(this.updateNegocioResponseSingle(negocio));
      // verificamos la paginación
      if (this._rows.length > this.pageSize) {
        // si tenemos una cantidad mayor de registros a la paginacion actual, eliminamos el ultimo registro
        this._rows.pop();
      }
      this.cd.detectChanges();
    }
  }

  getNegocios(reset = false) {
    // antes de buscar los negocios, normalizamos los filtros
    this.normalizeFilters();
    this.updateChips();

    if (reset) {
      this.currentPage = 0;
      this.negociosService.negociosFiltersAndSort = {
        ...this.negociosService.negociosFiltersAndSort,
        quickFilters: this.quickFiltersModels,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }
    }
    if (this.currentPage === 0) {
      this.negociosService.getNEWMetricas(
        this.currentPage,
        this.pageSize,
        this.sortColumn.filterOrderName,
        this.sortOrder,
        this.filters,
        this.quickFiltersModels
      ).take(1).subscribe(x => {
        this.metricasValues.setValues(x);
      });
    }
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.negociosService.getNewNegocios(
      this.currentPage,
      this.pageSize,
      this.sortColumn.filterOrderName,
      this.sortOrder,
      this.filters,
      this.quickFiltersModels
    ).subscribe(items => {
      this._rows = this.updateNegociosResponse(items);
      this.resultsFullCount = this._rows.length ? this._rows[0].CantidadNegocios : 0;
      this.resultsPageCount = this._rows.length ? this._rows[0].CantidadPaginas : 0;
      this.spinnerService.setSoftSpinnerShowFlag(false);
    }, () => this.spinnerService.setSoftSpinnerShowFlag(false));
  }

  updateNegociosResponse(items: NegocioViewModel[]) {
    return items.map(x => {
      return this.updateNegocioResponseSingle(x);
    });
  }

  updateNegocioResponseSingle(x: NegocioViewModel): NegocioListItem {
    // confirmacion class
    let confClass = !x.Confirmacion ? '' : x.Confirmacion.Estado.split(' ').map(w => w.toLowerCase()).slice(0, 2).join('-');
    if (['vencida', 'activa'].includes(confClass) && x.TipoNegocio && x.TipoNegocio.Tipo === NEGOCIO_TYPE_INTENCION) {
      confClass += '2';
    }
    // precio especial button
    const precEspeBtn = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_CrearPrecioEspecial) &&
      (this.precioEspecialArray.includes(x.Confirmacion.Estado) || x.PrecioEspecial > 0);
    return {
      ...x,
      needUpdate: false,
      isNew: false, updatePriceCheck: false,
      marcaTemporalDisplay: x.FechaModificacion ? moment.unix(x.FechaModificacion).format('DD/MM/YYYY HH:mm') : '-',
      confirmacionClass: confClass,
      fechaEstadoDisplay: x.Confirmacion.FechaEstado ? moment.unix(x.Confirmacion.FechaEstado).format('DD/MM/YYYY HH:mm') : '-',
      showPrecioEspecialButton: precEspeBtn,
      fechaVencimientoDisplay: x.Vencimiento ? moment.unix(x.Vencimiento).format('DD/MM/YYYY HH:mm') : '-',
      fechaCreacionDisplay: x.Vencimiento ? moment.unix(x.Fecha).format('DD/MM/YYYY HH:mm') : '-'
    } as NegocioListItem;
  }

  selectNegocio(i: number) {
    if (!this._simulator) {
      this.selectedIndex = this.selectedIndex === i ? -1 : i;
    }
  }

  accessRegister(i?: number) {
    if (!this._simulator) {
      this.router.navigate([PATH_NEGOCIO_DETAIL, this._rows[this.selectedIndex >= 0 ? this.selectedIndex : i].Id]);
    }
  }

  onClickPrecioEspecial(e: MouseEvent, row: NegocioListItem) {
    // Evitar seleccionar la fila al hacer click en precio especial
    e.stopPropagation();
    if (this.precioEspecialArray.includes(row.Confirmacion.Estado)) {
      this.dialogsService.showPrecioEspecialDialog({price: row.PrecioEspecial, currency: row.Moneda.Simbolo}, true)
        .take(1)
        .subscribe((res: any) => {
          if (res && res.price >= 0) {
            // Guardarlo en la db y actualizarlo en nuestra copia local
            const newPrice = res.price;
            this.spinnerService.setShowFlag(true);
            this.negociosService.addSpecialPrice(row.Id, newPrice).take(1).subscribe(_ => {
              row.PrecioEspecial = newPrice;
              this.spinnerService.setShowFlag(false);
              this.selectedIndex = -1;
              this.getNegocios(false);
            }, () => this.spinnerService.setShowFlag(false));
          }
        });
    } else {
      this.dialogsService.showPrecioEspecialDialog({
        fecha: moment(row.Confirmacion.FechaEstado * 1000).format('DD/MM/YY HH.mm') + 'hs',
        responsable: row.Confirmacion.UsuarioEstado
      }, false);
    }
  }

  changePageSize(e: number) {
    this.currentPage = e;
    this.getNegocios(true);
  }

  onGoToPage(next = true) {
    if (next) {
      if (this.currentPage < this.resultsPageCount - 1) {
        // avanzar pagina
        this.currentPage++;
        this.getNegocios();
      }
    } else {
      if (this.currentPage > 0) {
        // retroceder pagina
        this.currentPage--;
        this.getNegocios();
      }
    }

    this.negociosService.negociosFiltersAndSort.currentPage = this.currentPage;
  }

  updateChips() {
    this.chips = this.filters.getChipList();
  }

  // en esta funcion controlamos y coordinamos los 3 scrolls: el scroller, el header y el body
  onHorizontalScroll(origin: 'scroller' | 'header' | 'body', e: UIEvent, targets: HTMLDivElement[]) {
    /*
    * al hacer scroll enviamos un evento a esta funcion, pero cuando seteamos en esta misma funcion el scroll de los demas elementos
    * tambien creamos eventos causando un loop infinito. Para evitar esto usamos un identificador de scroll e ignoramos las llamadas
    * a scroll distintas de la ultima hasta pasado el tiempo de debounce
    * */
    if (this.canScroll || this.lastScrolled === origin) {
      this.lastScrolled = origin;
      this.canScroll = false;
    } else {
      return;
    }
    // cada vez que causamos un cambio en el scroll, reiniciamos el timer;
    window.clearTimeout(this.scrollTimer);
    // finalmente seteamos un nuevo timer en 50ms
    this.scrollTimer = window.setTimeout(() => {
      this.canScroll = true;
    }, 50);
    targets.forEach(x => {
      x.scrollLeft = (e.target as HTMLDivElement).scrollLeft;
    });
    this.marginLeft = (e.target as HTMLDivElement).scrollLeft + 'px';
  }

  openContextMenu(clientX: number, clientY: number, i: number, e?: PointerEvent) {
    if (!this._simulator) {
      if (e) {
        e.preventDefault();
      }
      this.selectedIndex = i;
      this.triggerMenu.openMenu();
      setTimeout(() => {
        const list = document.getElementsByClassName('negocios-context-menu');
        if (list) {
          const elem: any = list[0];
          elem.style.left = clientX + 'px';
          elem.parentElement.style.position = 'static';
          // Si hay espacio para desplegar el menú hacia abajo lo hacemos, sino lo desplegamos hacia arriba
          elem.style.top = window.innerHeight - clientY >= elem.offsetHeight ? clientY + 'px' : clientY - elem.offsetHeight + 20 + 'px';
        }
      }, 10);
      return false;
    }
  }

  showNegocioButton(accion: string) {
    if (this.selectedIndex >= 0) {
      return this.permisosService.showNegocioAction(
        accion,
        this._rows[this.selectedIndex].Confirmacion.Estado,
        this._rows[this.selectedIndex].TipoNegocio.Id);
    }
    return false;
  }

  getOppositeType() {
    if (this.selectedIndex >= 0) {
      return this._rows[this.selectedIndex].TipoNegocio.Tipo === NEGOCIO_TYPE_INTENCION ?
        NEGOCIO_TYPE_ORDEN :
        NEGOCIO_TYPE_INTENCION;
    } else {
      return '';
    }
  }

  headerAction(action: 'click' | 'dblClick' | 'hold', column: NegocioColumn) {
    if (this._simulator) { return; }
    if (action === 'click') {
      // al hacer click cambiamos el ordenamiento
      if (this.sortColumn.name !== column.name) {
        this.sortColumn = column;
        this.sortOrder = true;
        this.getNegocios();
      } else {
        this.sortOrder = !this.sortOrder;
        this.getNegocios();
      }

      this.negociosService.negociosFiltersAndSort.sort = {
        column: this.sortColumn,
        order: this.sortOrder,
      }
    } else if (action === 'dblClick' || action === 'hold') {
      // al hacer hold, o doble click abrimos el filtro asociado
      const filter = this.filters.getFilter(column.name);
      if (!filter) { return; }
      this.dialogsService.openNewNegFilterDialog(column.name, filter).take(1).subscribe(res => {
        if (!res) { return; }
        const response = res as NegNewFiltersDialogData;
        this.filters.setSingleFilter(response.column, response.data);
        this.negociosService.negociosFiltersAndSort.filters = this.filters;
        this.updateChips();
        this.getNegocios();
        if (response.data !== null) {
          // Enviamos un evento de filtro a Analytics
          window['dataLayer'].push({
            'event' : 'granos_filter',
            'filter_name' : response.column
          });
        }
      });
    }
  }

  onExport() {
    this.dialogsService.confirm('¿Desea exportar la lista de negocios?',
      'Se exportará la lista de negocios de acuerdo a los filtros actuales',
      'ACEPTAR',
      'CANCELAR')
      .take(1).subscribe(res => {
      if (res) {
        this.spinnerService.setShowFlag(true);
        this.negociosService.newExportToExcel(
          this.currentPage,
          this.pageSize,
          this.sortColumn.filterOrderName,
          this.sortOrder,
          this.filters,
          this.quickFiltersModels,
        )
        .take(1)
        .subscribe(() => {
          this.spinnerService.setShowFlag(false);
        }, () => {
          this.spinnerService.setShowFlag(false);
        });
      }
    });
  }

  showPrecioEspecialButton(c: NegocioListItem) {
    return this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_CrearPrecioEspecial) &&
      ([CONFIRMACION_VALUES.ACTIVA, CONFIRMACION_VALUES.MATCHEADA,
        CONFIRMACION_VALUES.AUTORIZADA, CONFIRMACION_VALUES.CONFIRMADA].includes(c.Confirmacion.Estado) || c.PrecioEspecial > 0);
  }

  onEditNegocio() {
    if (this.selectedIndex < 0) { return; }
    this.dialogsService.showNewNegocioResponsiveDialog(false, true, this._rows[this.selectedIndex].Id)
      .take(1).subscribe(value => {
      if (value) {
        this.selectedIndex = -1;
        this.getNegocios(true);
      }
    });
  }

  onDeleteNegocio() {
    if (this.selectedIndex < 0) { return; }
    this.dialogsService.showTextAreaDialog(
      '¿Está seguro de que desea anular este negocio?', null,
      'SÍ, ANULAR',
      'NO, CANCELAR', true)
      .take(1).subscribe(res => {
      if (res) {
        // Guardar el índice en caso de que el usuario haga click en otra fila antes de que el borrado vuelva desde la API
        const index = this.selectedIndex;
        this.spinnerService.setShowFlag(true);
        this.negociosService.deleteNegocio(this._rows[this.selectedIndex].Id.toString(), res).take(1).subscribe(_ => {
          this._rows.splice(index, 1);

          // Si el selectedRegister sigue siendo el que borramos le asignamos -1 (esto es: ninguno seleccionado)
          if (this.selectedIndex === index) {
            this.selectedIndex = -1;
          }

          this.spinnerService.setShowFlag(false);
        }, () => this.spinnerService.setShowFlag(false));
      }
    });
  }

  onDuplicateNegocio() {
    if (this.selectedIndex < 0) { return; }
    this.dialogsService.showNewNegocioResponsiveDialog(true, false, this._rows[this.selectedIndex].Id)
      .take(1).subscribe( (value) => {
      if (value) {
        this.selectedIndex = -1;
        this.currentPage = 0;
        this.getNegocios();
      }
    });
  }

  onCreateNewNegocio() {
    this.dialogsService.showNewNegocioResponsiveDialog()
      .take(1).subscribe(value => {
      if (value) {
        this.selectedIndex = -1;
        this.getNegocios(true);
      }
    });
  }

  onSwapNegocioType() {
    this.dialogsService.confirm(null,
      '¿Está seguro de que quiere cambiar el tipo de este negocio?',
      'SÍ, CAMBIAR',
      'NO, CANCELAR')
      .take(1)
      .subscribe( res => {
        if (res) {
          const index = this.selectedIndex;
          // Cambiar el tipo de negocio en el listado
          if (this._rows[index].TipoNegocio.Tipo === NEGOCIO_TYPE_INTENCION) {
            this._rows[index].TipoNegocio.Tipo = NEGOCIO_TYPE_ORDEN;
            this._rows[index].TipoNegocio.Id = NEGOCIO_TYPE_ORDEN_ID;
          } else {
            this._rows[index].TipoNegocio.Tipo = NEGOCIO_TYPE_INTENCION;
            this._rows[index].TipoNegocio.Id = NEGOCIO_TYPE_INTENCION_ID;
          }
          // Y en la API
          this.negociosService.swapNegocioType(this._rows[index].Id).take(1).subscribe(() => {});
        }
      });
  }

  negociosToUpdate() {
    return this._rows.filter(x => x.updatePriceCheck);
  }
}

interface NegocioListItem extends NegocioViewModel {
  needUpdate: boolean;
  updatePriceCheck: boolean;
  isNew: boolean;
  marcaTemporalDisplay: string;
  confirmacionClass: string;
  fechaEstadoDisplay: string;
  showPrecioEspecialButton: boolean;
  fechaVencimientoDisplay: string;
  fechaCreacionDisplay: string;
}

interface NegocioColumn {
  name: string;
  width: number;
  filterOrderName: string;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios/negocio-list/negocio-list.component.ts